import { Link } from 'react-router-dom';

import { appConfig } from '../config/appConfig';

export const COPYRIGHT_LAST_UPDATED = '2026年6月9日';

const COPYRIGHT_HOLDER = '北京忆流记心计算机网络工作室（个体工商户）';

export function CopyrightDocument() {
  return (
    <article className="text-[15px] leading-7 text-[#2D3139]">
      <header className="mb-6">
        <h1 className="mb-1 text-2xl font-extrabold tracking-tight text-ink">版权声明</h1>
        <p className="text-sm text-muted">
          {appConfig.appName} · 最后更新：{COPYRIGHT_LAST_UPDATED}
        </p>
      </header>

      <div className="mb-6 rounded-md border-l-[3px] border-primary bg-[#EAF2FF] px-3.5 py-3 text-sm text-[#2D3139]">
        本页面声明颗粒日记官方网站、Web 应用，以及 iOS / Android 移动端与 iPad 平板端应用程序相关著作权与使用边界。
        访问或使用上述产品，即表示您已阅读并理解本声明。
      </div>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">一、著作权人</h2>
        <p>
          「颗粒日记」相关产品与服务的著作权及相关知识产权，由 <strong className="font-semibold text-ink">{COPYRIGHT_HOLDER}</strong> 享有或依法取得授权，受中华人民共和国著作权法及其他适用法律保护。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">二、受保护客体</h2>
        <p className="mb-3">本声明适用于但不限于以下产品与载体：</p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li>
            <strong className="font-semibold text-ink">官方网站：</strong>
            <a href={appConfig.sitePublicUrl} className="text-primary hover:underline" target="_blank" rel="noopener noreferrer">
              {appConfig.sitePublicUrl}
            </a>
            及其下属页面
          </li>
          <li>
            <strong className="font-semibold text-ink">Web 应用：</strong>
            颗粒日记浏览器端产品（含桌面与移动浏览器访问形态）
          </li>
          <li>
            <strong className="font-semibold text-ink">移动应用程序：</strong>
            iOS 与 Android 客户端（Bundle ID / 包名：<code className="rounded bg-[#F0F3F8] px-1.5 py-0.5 text-sm">com.keliriji.app</code>）
          </li>
          <li>
            <strong className="font-semibold text-ink">平板端应用程序：</strong>
            在 iPad 等平板设备上运行的颗粒日记客户端界面、交互与配套资源
          </li>
          <li>
            <strong className="font-semibold text-ink">受保护内容：</strong>
            产品名称、界面设计、图标、文案、代码、文档、帮助说明及其他原创作品
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">三、权利保留</h2>
        <p className="mb-3">除法律法规另有规定或著作权人书面同意外，任何单位或个人不得实施下列行为：</p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li>复制、修改、翻译、汇编、传播或公开发布本产品的软件、页面或文档</li>
          <li>对应用程序进行反编译、反汇编、破解或绕过技术保护措施</li>
          <li>去除、篡改或伪造版权标识、商标标识或权利管理信息</li>
          <li>将本产品用于搭建竞争性服务，或进行未授权的商业性再分发</li>
        </ul>
        <p>个人用户在遵守用户协议与法律法规的前提下，可按产品设计的正常功能使用本服务。</p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">四、用户内容与第三方材料</h2>
        <p className="mb-3">
          用户上传的学习素材、笔记、标注及其他内容的知识产权归用户或原权利人所有。用户应确保对所上传内容享有合法权利，不得侵犯他人著作权、肖像权或其他合法权益。
        </p>
        <p>
          产品中可能展示或引用的第三方教材、图片、文字等，其权利归属原作者或权利人。颗粒日记仅提供整理、学习与复习工具，不对第三方内容的权利状态作担保。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">五、商标与品牌</h2>
        <p>
          「颗粒日记」名称、标识、图形及其他商业标识，未经书面许可，不得擅自使用、仿冒或作为商业推广标识使用，以避免造成来源混淆。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">六、侵权通知</h2>
        <p className="mb-3">
          如您认为颗粒日记产品中的内容侵犯了您的合法权益，请通过应用内「反馈」或网站联系方式提交书面通知，并尽量提供：
        </p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li>权利人的身份证明与联系方式</li>
          <li>权属证明材料</li>
          <li>涉嫌侵权内容的准确位置与描述</li>
          <li>真实、完整的侵权声明</li>
        </ul>
        <p>我们将在核实后依法及时处理。</p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">七、备案信息</h2>
        <ul className="list-disc space-y-1.5 pl-5">
          <li>网站备案：{appConfig.icpWebsite}</li>
          <li>App 备案：京ICP备2026007820号-2A</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">八、相关链接</h2>
        <p className="flex flex-wrap gap-x-4 gap-y-2">
          <Link to="/privacy" className="text-primary hover:underline">隐私政策</Link>
          <Link to="/terms" className="text-primary hover:underline">用户服务协议</Link>
          <Link to="/about" className="text-primary hover:underline">关于颗粒日记</Link>
          <Link to="/support" className="text-primary hover:underline">联系我们</Link>
        </p>
      </section>

      <p className="border-t border-border pt-6 text-center text-sm text-[#8A9CB8]">
        © {new Date().getFullYear()} {COPYRIGHT_HOLDER} · 版权所有
      </p>
    </article>
  );
}
